import { compact, map, filter, every, isEmpty, some, get, toLower, toString, includes } from 'lodash'

const filteredVMData = ({ vms: customers, filters }) => compact(map(customers, (customer) => {
  const vms = filter(customer.vms, vm => {
    const filterResults = {}

    if (filters.locations != 'All') {
      filterResults['locations'] = some(filters.locations, location => location.value === get(vm, 'location'))
    }
    if (filters.clusters != 'All') {
      filterResults['clusters'] = some(filters.clusters, cluster => cluster.value === get(vm, 'cluster'))
    }
    if (filters.dataProtectionStatus != 'All') {
      filterResults['dataProtectionStatus'] = some(filters.dataProtectionStatus, dataProtectionStatus => toLower(dataProtectionStatus.value) === toLower(get(vm, 'data_protection_status')))
    }
    if (filters.dataProtectionCompliance != 'All') {
      filterResults['dataProtectionCompliance'] = some(filters.dataProtectionCompliance, dataProtectionCompliance => toLower(dataProtectionCompliance.value) === toLower(get(vm, 'data_protection_compliance')))
    }
    if (filters.antivirusStatus != 'All') {
      filterResults['antivirusStatus'] = some(filters.antivirusStatus, antivirusStatus => toLower(antivirusStatus.value) === toLower(get(vm, 'antivirus_status')))
    }
    if (filters.antivirusCompliance != 'All') {
      filterResults['antivirusCompliance'] = some(filters.antivirusCompliance, antivirusCompliance => {
        if (antivirusCompliance.value == 'wrongAntivirusProduct') {
          return toLower(antivirusCompliance.value) === toLower(get(vm, 'wrong_av_product'))
        } else {
          return toLower(antivirusCompliance.value) === toLower(get(vm, 'antivirus_compliance'))
        }
      })
    }
    if (filters.patchingStatus != 'All') {
      filterResults['patchingStatus'] = some(filters.patchingStatus, patchingStatus => toLower(patchingStatus.value) === toLower(get(vm, 'patching_status')))
    }
    if (filters.patchingCompliance != 'All') {
      filterResults['patchingCompliance'] = some(filters.patchingCompliance, patchingCompliance => toLower(patchingCompliance.value) === toLower(get(vm, 'patching_compliance')))
    }
    if (filters.monitoringCompliance != 'All') {
      filterResults['monitoringCompliance'] = some(filters.monitoringCompliance, monitoringCompliance => toLower(monitoringCompliance.value) === toLower(get(vm, 'monitoring_compliance')))
    }
    if (filters.osSupported != 'All') {
      filterResults['osSupported'] = some(filters.osSupported, osSupported => toLower(osSupported.value) === toLower(get(vm, 'os_supported')))
    }
    
    if (filters.customerStatus != 'All') {
      filterResults['customerStatus'] = some(filters.customerStatus, customerStatus => customerStatus.value === get(vm, 'customer_status'))
    }

    if (filters.calligoManagement != 'All') {
      filterResults['calligoManagement'] = some(
        filters.calligoManagement,
        calligoManagement => calligoManagement.value === toString(get(vm, 'calligo_management'))
      )
    }

    if (filters.deviceTypes != 'All') {
      filterResults['deviceTypes'] = some(filters.deviceTypes, deviceType => deviceType.value === get(vm, 'device_type'))
    }

    if (filters.powerState != 'All') {
      filterResults['powerState'] = filters.powerState === toString(get(vm, 'power_state'))
    }

    if (filters.reservationCost != 'All') {
      filterResults['reservationCost'] = some(filters.reservationCost, reservationCost => reservationCost.value === get(vm, 'memory_reservation_cost_bool'))
    }

    return (every(filterResults, (value, key) => value === true) || isEmpty(filterResults))
  })

  if (vms.length == 0) { return null }
  return { ...customer, vms }
}))

export default filteredVMData
export { filteredVMData }
